// @ts-strict-ignore
import type { AggregationOption } from './AggregationSelect';

export const AGGREGATION_OPTIONS: AggregationOption[] = [
  { value: 'count_distinct', label: 'Distinct Count' },
  { value: 'avg', label: 'Average' },
  { value: 'count', label: 'Count' },
  { value: 'max', label: 'Max' },
  { value: 'min', label: 'Min' },
  { value: 'sum', label: 'Sum' },
];
export const SUBJECT_OPTIONS: AggregationOption[] = [{ value: 'entities', label: 'Entities' }];
export const SCOPE_OPTIONS: AggregationOption[] = [
  { value: 'entity', label: 'For the Entity being evaluated' },
  { value: 'group', label: 'For all Entities in this Group' },
  { value: 'all', label: 'Across all Entities' },
];
export const TIMEFRAME_NUMBER_OPTIONS: AggregationOption[] = Array.from(
  { length: 90 },
  (_, i) => ({ value: String(i + 1), label: String(i + 1) }),
);
export const TIMEFRAME_UNIT_OPTIONS: AggregationOption[] = [
  { value: 'days', label: 'days' },
  { value: 'weeks', label: 'weeks' },
  { value: 'months', label: 'months' },
];
